import Header from './modules/header'
import HeaderAJ from './modules/header-aj'
import Vh from './modules/vh'
import Locator from './modules/locator'
import Fancybox from '@fancyapps/fancybox'
import ProjectFancybox from './modules/project-fancybox'
import { Popup, Mobile, Tabs, TRANSITION_END, getCookie, setCookie, Carousel_CoreInit, Scrollbar, AjaxifyGrid_CoreInit } from './core'
import './plugins/forms'
import './plugins/slide-selector-menu'
import './plugins/scroll-to-anchor'
import './plugins/stick-to-container'
import './plugins/ajax-post-toolbar'
import './plugins/project-gallery'
//import './plugins/compare-row'
import './plugins/stairs-effect'
import './plugins/tabs'
import './plugins/extending-list'
import './plugins/grid-overlap'
import './plugins/parallax'
import './plugins/section-popup'
import './plugins/video-autoplay'
import './plugins/dynamic-text'
import './plugins/mode-inspiration'
import './plugins/random-content'

AjaxifyGrid_CoreInit([
  {
    classSelector: 'grid--postitem__attachment',
    afterUpdate: function(grid) {
      ProjectFancybox.init();
    },
    afterReplace: function(grid) {
      ProjectFancybox.init()
      $('.js-remove-context').click(function() {
        window.scrollTo(0, 0)
        $('.mode-inspiration__filters .grid-tax-filters-context .select__options ul li:first-child').click();
        $('.mode-inspiration__filters__submit').trigger('click');
      })
    },
    beforeAppend: function(data) {
      if ($(data).find('.js-remove-context--style').length) {
        var style = $('.mode-inspiration__filters .grid-tax-filters-style .js-ajaxify-select option:selected').text()
        $(data).find('.js-remove-context--style').html(style)
      }
      return data;
    },
  },
  {
    classSelector: 'grid--postitem__project',
    beforeAppend: function(data) {
      var section = $('.template-inspiration .carousel--postitem__project.carousel--style--image-slider').closest('.page-section');

      if ($(data).find('.grid__item').length < 3) {
        section.css('--max-height', section.innerHeight() + 'px')
        section.addClass('--hide');
      } else {
        section.css('--max-height', '');
        section.removeClass('--hide');
      }
      return data;
    },
  }
])

Carousel_CoreInit([
  {
    classSelector: 'carousel--style--image-slider',
    swiperOptions: {
      loopAdditionalSlides : 2,
    },
  },
  {
    classSelector: 'carousel--style--collabo',
    swiperOptions: {
      on: {
        afterInit: function(swiper) {
          swiper.$el.closest('.carousel__container').append(swiper.$el.find('.swiper-button-prev'))
          swiper.$el.closest('.carousel__container').append(swiper.$el.find('.swiper-button-next'))
        },
      },
    },
  },
  {
    classSelector: 'carousel--style--realisations',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          loopFillGroupWithBlank: true,
          spaceBetween: 10,
        },
      },
      pagination: {
        el: '.carousel--style--realisations__progress-bar',
        type: 'progressbar',
      },
    },
    carouselOptions: {
      forceRebuild: true,
    }
  },
  {
    classSelector: 'carousel--style--feature',
    swiperOptions: {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        renderBullet: function(index, className) {
          index = (index < 9) ? '0' + (index + 1) : index + 1
          return '<span class="' + className + '">' + index + '</span>'
        },
      },
      on: {
        beforeInit: function(swiper) {
          swiper.$el.find('.card-feature').each(function(el, index) {
            let $image = $(el).find('.picture').clone().attr('data-index', index).attr('aria-hidden', index ? 'true' : 'false')
            $image.appendTo(swiper.$el.closest('.feature').find('.feature__image'))
          })
          swiper._mlmi_activeIndexChange = function(swiper) {
            if (swiper.previousRealIndex != undefined && swiper.previousRealIndex != swiper.realIndex) {
              swiper.previousRealIndex = swiper.realIndex
              swiper.$el.closest('.feature').find('.feature__image .picture[aria-hidden="false"]').attr('aria-hidden', 'true')
              swiper.$el.closest('.feature').find('.feature__image .picture[data-index="' + swiper.realIndex + '"]').attr('aria-hidden', 'false')
            }
          }
        },
        init: function(swiper) {
          swiper.previousRealIndex = -1
          swiper._mlmi_activeIndexChange(swiper)
        },
        activeIndexChange: function(swiper) {
          swiper._mlmi_activeIndexChange(swiper)
        },
      },
    },
  },
])

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    scroll: $(window).ScrollEvents(),
  }

  /* Header */
  if (site_l10n.site_id == '1') {
    HeaderAJ.init()
  } else {
    Header.init()
  }

  Vh.init()

  /* Locator */
  Locator.init()

  /* Popup */
  Popup.init()

  $('.bg-video').each(function() {
    $(this).VideoBg();
  })

  /* Dynamic Text */
  $('.dynamic-text').each(function() {
    $(this).DynamicText()
  })

  /* Job offers */
  $('.js-extending-list').each(function() {
    $(this).ExtendingList()
  })

  /* Forms */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  $('.contact-form').each(function() {
    $(this).ContactForm()
  })

  $('.application-form').each(function() {
    $(this).ApplicationForm()
  })

  $('.quote-form').each(function() {
    $(this).QuoteForm()
  })

  $('.quote-short-form').each(function() {
    $(this).QuoteShortForm()
  })

  $('.retailer-form').each(function() {
    $(this).RetailerForm()
  })

  $('.call-back-form').each(function() {
    $(this).CallBackForm()
  })

  $('.quick-lead-form').each(function() {
    $(this).QuickLeadForm()
  })

  $('.select__options').each(function() {
    new Scrollbar($(this))
  })

  /* Contact map */
  $('.header__main-menu .main-menu, .header__sub-menu .main-menu').each(function() {
    $(this).slideSelectorMenu()
  })

  $('.images-layout-row .images-layout__item:last-child .picture').each(function() {
    $(this).parallax(-.4, 'desktop')
    $(this).parallax(-.2, 'mobile')
  })

  $('.text-row .images-layout__item:last-child .picture').each(function() {
    $(this).parallax(-.2)
  })

  $('.custom-layout .--image-2 .picture').each(function() {
    $(this).parallax(-.2)
  })

  $('.custom-layout .--image-1 .picture').each(function() {
    $(this).parallax(.1)
  })

  /* Create a menu out of titles in content */
  $('.table-of-contents a').each(function() {
    $(this).scrollToAnchor();
  })

  /* Make anchor menu stick to the left when we scroll */
  $('.js-anchor-menu').each(function() {
    $(this).stickToContainer('.js-anchor-menu-container', $('header').height() + 60);
  })

  /* Enable post toolbar */
  $('.ajax-post-toolbar').each(function() {
    $(this).ajaxPostToolbar('.ajax-post-toolbar-results', '.ajax-post-toolbar-load-more');
  })

  /* Gallery on Project page */
  $('.js-project-gallery-wrapper').each(function() {
    $(this).projectGallery();
  })

  $('.grid-overlap').each(function() {
    $(this).gridOverlap()
  })

  $('.video-autoplay').each(function() {
    $(this).VideoAutoplay();
  })

  /* Fancybox */
  $('[data-fancybox]').fancybox({
    loop: true,
    buttons: ['close'],
    transitionEffect: 'slide',
    i18n: {
      fr: {
        CLOSE: "Fermer",
        NEXT: "Photo suivante",
        PREV: "Photo précédente",
      },
    },
    lang: 'fr',
    backFocus: false,
  })

  /* Tabs */
  $('.tabs.tabs--bottom-navigation').each(function() {
    $(this).navigationAfterContent();
  });
  Tabs.init() // after navigationAfterContent

  /* Clic anchor */
  $('main a[href^="#"]').on('click', function() {
    if ($('a[name="' + $(this).attr('href').substring(1) + '"]').length) {
      let targetTop = $('a[name="' + $(this).attr('href').substring(1) + '"]').offset().top
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      return false
    } else if ($($(this).attr('href')).length) {
      let targetTop = $($(this).attr('href')).offset().top - $('.header').outerHeight(false) - 32
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      return false
    }
  })

  /* Search */
  $('input[name="s"]').on('focus', function() {
    let searchField = $(this)
    setTimeout(function() {
      searchField.get(0).select()
    }, 25)
  })

  if (site_l10n.site_id == '3') {
    /* Stairs Effect on multiple columns */
    $('.row.stairs-effect').each(function() {
      $(this).stairsEffect();
    });
  }

  /* Designer fixed content */
  if (site_l10n.site_id == '1' || site_l10n.site_id == '3') {
    $('.single-designer__featured-image .picture-content').each(function() {
      let self = $(this)
      self.FixedContent({
        topBlocker: $('.header'),
        bottomBlocker: $('.footer'),
        container: self.closest('.text-content'),
        limitFromTop: 16,
        mobile: false,
        validate: function() {
          return self.outerHeight(false) >= self.closest('.single-designer__featured-image').outerHeight(false)
        },
      })
    })
  }

  /* Ateliers Jacob only */
  if (site_l10n.site_id == '1') {
    // $('.js-compare__sticky-content').each(function() {
    //   if ($(this).closest('div[class^="col-"]').height() > $(this).height()) {
    //     $(this).closest('.row').after('<div class="js-compare__sticky-content__end"></div>')
    //     let fixedContent = $(this).FixedContent({
    //      topBlocker: $('.header'),
    //      bottomBlocker: $(this).closest('.row').next('.js-compare__sticky-content__end'),
    //      container: $(this).closest('div[class^="col-"]'),
    //      limitFromTop: 50,
    //      mobile: true,
    //     })
    //   }
    // })

    /* Stairs Effect on multiple columns */
    $('.row.stairs-effect').each(function() {
      $(this).stairsEffect();
    });

    /* make videos look like images */
    $('.video-loop').each(function() {
      let self = $(this)
      let video = $(this).find('video')
      if (video.data('loaded')) {
        setTimeout(function() {
          picture(video.get(0))
          video.get(0).play()
        }, 60)
      } else {
        video.on('canplaythrough', function() {
          picture(video.get(0))
          video.get(0).play()
        })
      }
    })

    /* Carousel hint animation */
    $('.carousel.swiper-initialized:not(.carousel--style--realisations > .carousel):not(.carousel--style--feature > .carousel)').each(function() {
      let carousel = $(this).data('carousel')
      if (carousel != undefined) {
        carousel.unhintAnimation = function() {
          carousel.find('.swiper-slide').off(TRANSITION_END, carousel.unhintAnimation)
          carousel.find('.swiper-slide').removeClass('swiper-slide--hint')
          carousel.find('.swiper-scrollbar').removeClass('swiper-scrollbar--hint')
        }
        carousel.hintAnimation = function() {
          carousel.find('.swiper-slide').addClass('swiper-slide--hint').on(TRANSITION_END, carousel.unhintAnimation)
          carousel.find('.swiper-scrollbar').addClass('swiper-scrollbar--hint')
          carousel.hintTimeout = setTimeout(carousel.hintAnimation, 12500)
        }
        carousel.firstMove = function() {
          clearTimeout(carousel.hintTimeout)
          carousel.swiper.off('sliderFirstMove', carousel.firstMove)
          carousel.find('.swiper-slide').off(TRANSITION_END, carousel.unhintAnimation)
          carousel.find('.swiper-slide').removeClass('swiper-slide--hint')
          carousel.find('.swiper-scrollbar').removeClass('swiper-scrollbar--hint')
        }
        carousel.inViewCheck = function(top) {
          let targetY = carousel.offset().top + (carousel.outerHeight(false) / 1.5) - top - $(window).height()
          if (targetY < 0) {
            $.mlmi.scroll.removeCallback(carousel.inViewCheck)
            carousel.swiper.on('sliderFirstMove', carousel.firstMove)
            carousel.hintTimeout = setTimeout(carousel.hintAnimation, 3250)
          }
        }
        $.mlmi.scroll.add(carousel.inViewCheck)
      }
    })
  }

  /* Close popup */
  if (getCookie('popup-displayed') != 'yes') {
    setCookie('popup-displayed', 'yes', 60*60*24)
    $('.popup').each(function() {
      let $popup = $(this)
      $popup.attr('aria-hidden', 'false')
      $popup.find('.popup__close').on('click', function() {
        $popup.attr('aria-hidden', 'true')
      })
    })
  }

  $('.section-popup').each(function() {
    $(this).SectionPopup()
  })

  $('.grid--style--random-content').each(function() {
    $(this).randomContent()
  })

  $('.grid-search__field').each(function() {
    $(this).FloatingLabel()
  })

  /* Mode Inspiration - Fancybox */
  ProjectFancybox.init();

  $('.mode-inspiration__filters').each(function() {
    $(this).modeInspiration()
  })

  $('.footer .footer-mobile .footer-mobile__item--parent .footer-mobile__link').click(function() {
    if ($(this).closest('.footer-mobile__item--parent').hasClass('--selected')) {
      $(this).closest('.footer-mobile__item--parent').removeClass('--selected');
    } else {
      $('.footer .footer-mobile .footer-mobile__item').removeClass('--selected');
      $(this).closest('.footer-mobile__item--parent').addClass('--selected');
      let targetTop = $(this).offset().top - window.innerHeight + $(this).height() + 30;
      var max_height = window.innerHeight - $('.header').height() - $(this).height() - 65;
      $('.footer .footer-mobile').css('--max-height', max_height + 'px');
      if ($(this).closest('.footer-mobile__item--parent').find('.footer-mobile__sub-menu').outerHeight() > $(this).offset().top - $(window).scrollTop() - 50) {
        $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      }
    }
    return false;
  })

  $(window).click(function() {
    $('.footer .footer-mobile .footer-mobile__item').removeClass('--selected');
  });

  $('.footer .footer-mobile .footer-mobile__link').click(function(event){
    event.stopPropagation();
  });
})
